import { getInfo } from '@/api/user'
import { getChatInfo } from '@/api/chat'
import { logout } from '@/api/common'
import NIM from '@yxim/nim-web-sdk/dist/SDK/NIM_Web_NIM.js';
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setStore, getStore } from '@/utils/util';
import { decrypt } from '@/utils/rsaEncrypt'
import Cookies from "js-cookie";
import router from '@/router/routers'
import { timestampToDate, timestampToDate1, message } from "@/utils/IM";
import { Notification, MessageBox } from 'element-ui'
let self = null;
const onConnect = () => {
    console.log('连接成功')
}

const onWillReconnect = (obj) => {
    // 此时说明 `SDK` 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
}
const onDisconnect = (error) => {
    // 此时说明 `SDK` 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
    console.log(error)
    console.log('丢失连接');
    if (error) {
        switch (error.code) {
            // 账号或者密码错误, 请跳转到登录页面并提示错误
            case 302:
                break;
            // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
            case 417:
                break;
            // 被踢, 请提示错误后跳转到登录页面
            case 'kicked':
                // 被踢后，销毁NIM实例
                self('DESTROY');
                // if (window.location.href.indexOf('#/projectDetails')>-1||window.location.href.indexOf('#/APPblankDetail')>-1||window.location.href.indexOf('#/blankDetail')>-1) {
                // }else{
                //     self("CONNECT");
                // }
                break;
            default:
                break;
        }
    }

}
const onError = (error) => {
    // console.log(error)
}
const onmsg = (msg) => {
    // console.log(msg, '收到消息了');
}
const onSessions = (sessions) => {
    self('SET_CHATLIST', sessions);
    self('SET_ALLUNREAD', sessions);


}
const onUpdateSession = (sessions) => {
    console.log(sessions, '会话列表更新了');
    self('CHANGE_CHATLIST', sessions);
}
const setNIM = (nim) => {
    self('SET_NIM', nim)
}
const getHistoryMsgsDone = (error, obj) => {
    self('PUSH_CHATLISTITEMDETIAL', obj.msgs);
}
const sendMsgReceiptDone = (error, obj) => {
    // console.log('发送消息已读回执' + (!error ? '成功' : '失败'), error, obj);
}
const onsysmsg = (data) => {
    // console.log('收到系统通知', data);
    self('ONSYSMSG', data);
}
const sendMsgDone = (error, msg) => {
    self('UPDATA_CHATDETIAL');
    // console.log('发送消息' + (!error ? '成功' : '失败'), error, msg);
}

const user = {
    state: {
        token: getToken(),
        user: {},
        menuAuth: [],
        navs: [],
        routerAuth: [],
        buttonAuth: [],
        roles: [],
        // 最近会话列表
        chatList: [],
        // 第一次加载菜单时用到
        loadMenus: false,
        currentChat: {},//当前聊天对象
        NIM: null,
        chatItemDetial: [],
        userAccount: getStore('cImName'),
        userPassword: getStore('imPassword'),
        // userAccount: '1130022915496515d3c',
        // userPassword: '7e5b8cb7',
        allUnread: 0,
        auditMessageNotificationCount: 0,
        resumeMailingNotificationCount: 0,
        loading: false,
        version: null,
        // sale_index: null,
        // sale_type: null,
    },

    mutations: {
        UPDATA_CHATDETIAL: (state) => {
            if (state.currentChat.sessionId) {
                self('GET_CHATDETIAL', state.currentChat);
            }
        },
        ONSYSMSG: (state, data) => {
            if (data.type == "deleteMsg") {
                var content = {
                    type: 'deleteMsg',
                    data,
                };
                if (data.from == state.userAccount) {
                    content.text = '你撤回了一条消息';
                    var msg = state.NIM.sendCustomMsg({
                        scene: 'p2p',
                        to: data.to,
                        content: JSON.stringify(content),
                        isLocal: true,
                        done: sendMsgDone
                    });

                } else {
                    content.text = '对方撤回了一条消息';
                    var msg = state.NIM.sendCustomMsg({
                        scene: 'p2p',
                        to: data.from,
                        content: JSON.stringify(content),
                        isLocal: true,
                        done: sendMsgDone
                    });
                }
            }
        },
        SALE_INDEX: (state, index) => {
            // state.sale_index = index;
            setStore("sale_index", index);
            console.log(index, 'store')
        },
        SALE_version: (state, res) => {
            state.version = res;
        },
        SALE_TYPE: (state, type) => {
            setStore("sale_type", type);
            // state.sale_type = type;
            // console.log(type,'sale状态')
        },
        SET_TOKEN: (state, token) => { //操作token；
            state.token = token
        },
        SET_USER: (state, res) => { //操作user；
            state.user = res.details;
            // state.userAccount = res.details.imNameC;
            // state.userPassword = res.details.imPassword;
        },
        SET_NAVS: (state, res) => {
            state.navs = res;
        },
        CONNECT: (state) => {
            state.NIM.connect();
        },
        DESTROY: (state) => {
            if (state.NIM) {
                state.NIM.destroy();
            }
        },

        SET_ALLUNREAD: (state, res) => {
            state.allUnread = 0;
            res.forEach(item => {
                state.allUnread += item.unread;
            });
        },
        // SET_ROLES: (state, roles) => {
        //   state.roles = roles
        // },   
        SET_AUTH: (state, res) => {
            state.menuAuth = res.menuList;
            state.routerAuth = res.routeList;
            state.buttonAuth = res.buttonList;
        },
        SET_CHATLIST: (state, res) => {
            let arr  = [...res];
            for (let index = 0; index < res.length; index++) {
                if (res[index].lastMsg.target != state.userAccount) {
                    state.NIM.getUser({
                        account: res[index].lastMsg.target, done: async (err, data) => {
                            if (data) {
                                res[index].lastMsg.avatar = data.avatar;
                                res[index].lastMsg.nick = data.nick;
                            }
                            let item = res[index].lastMsg;
                            let content;
                            if (item.type == 'custom' && JSON.parse(item.content).type == 27) {
                                 content = JSON.parse(item.content).data.chatJobId 
                            }
                            let obj = {
                                cImName: res[index].lastMsg.target,
                                jobId:content
                            }
                            if (!obj.jobId) {
                               delete obj.jobId
                            }
                            let data1 = await getChatInfo(obj);
                            let data2 = {...data1.resume,project:data1.project};
                            if (!data2.project) {
                               delete data2.project
                            }
                            arr.splice(index,1,message({ ...res[index].lastMsg, unread: res[index].unread ,...data2}))
                        }
                    })
                }
            }
            state.chatList=arr;
            self('SET_ALLUNREAD', state.chatList);

        },
        PUSH_CHATLISTITEMDETIAL:async (state, res) => {
            let project = '';
            if (state.currentChat && state.currentChat.unread > 0) {
                state.NIM.resetSessionUnread(state.currentChat.sessionId);
                state.NIM.sendMsgReceipt({
                    msg: res[0],
                    done: sendMsgReceiptDone,
                });
            }
            res.reverse();
            let arr = [...res];
            for (let index = 0; index < res.length; index++) {
                const item = res[index];
                if (index === 0) {
                    item['displayTimeHeader'] = timestampToDate(item.time);
                } else {
                    let delta = (item.time - res[index - 1].time) / (30 * 60 * 1000);
                    if (delta > 1) {
                        // 距离上一条，超过两分钟重新计算头部
                        item['displayTimeHeader'] = timestampToDate(item.time);
                    }
                }
                if (item.content && item.type == 'custom' && JSON.parse(item.content).type == 27) {
                      let resProject = await getChatInfo({
                        cImName: item.target,
                        jobId: JSON.parse(item.content).data.chatJobId
                    })
                    project = resProject.project;
                    item.project = project;
                    arr.splice(index,1,message(item))
                }else{
                    item.project = project;
                    arr.splice(index,1,message(item))
                }
            }
            state.chatItemDetial=arr;
            // state.chatItemDetial.forEach( (item, index) => {
               
            //     // return message(item);
            // })
            console.log(state.chatItemDetial);
            state.loading = false;

        },
        CHANGE_CHATLIST: async (state, res) => {
            if (res.lastMsg.status == "success") {
                let newChatList=[...state.chatList]
                // 判断云信ID是否存在消息列表内决定插入还是更新
                if (!newChatList.some(item => item.sessionId == res.id)) {
                    state.NIM.getUser({
                        account: res.lastMsg.target, done: async (err, data) => {
                            if (data) {
                                res.lastMsg.avatar = data.avatar;
                                res.lastMsg.nick = data.nick;
                            }
                            let item = res.lastMsg;
                            let content;
                            if (item.type == 'custom' && JSON.parse(item.content).type == 27) {
                                 content = JSON.parse(item.content).data.chatJobId 
                            }
                            let obj = {
                                cImName: res.lastMsg.target,
                                jobId:content
                            }
                            if (!obj.jobId) {
                               delete obj.jobId
                            }
                            let data1 = await getChatInfo(obj);
                            let data2 = {...data1.resume,project:data1.project};
                            if (!data2.project) {
                               delete data2.project
                            }
                            newChatList = [{...message({  ...res.lastMsg, unread: res.unread }), ...data2},...newChatList,];
                            self('SET_ALLUNREAD', newChatList);
                            state.chatList= newChatList;
                        }
                    })

                } else {
                    for (let index = 0; index < newChatList.length; index++) {
                        let item = newChatList[index];
                        if (item.sessionId == res.id&&res.unread>=item.unread) {
                            newChatList.splice(index, 1);
                            let content;
                            if (res.lastMsg.type == 'custom' && JSON.parse(res.lastMsg.content).type == 27) {
                                 content = JSON.parse(res.lastMsg.content).data.chatJobId 
                            }
                            let obj = {
                                cImName: res.id.split('-')[1],
                                jobId:content
                            }
                            if (!obj.jobId) {
                               delete obj.jobId
                            }
                            let data1 = await getChatInfo(obj);
                            let data2 = {...data1.resume,project:data1.project};
                            if (!data2.project) {
                               delete data2.project
                            }
                           
                            item = { ...data2, ...res.lastMsg, unread: res.unread, avatar: item.avatar, nick: item.nick };
                            newChatList.unshift(message(item));
                        }else if(item.sessionId == res.id&&res.unread<item.unread){
                            let content;
                            if (res.lastMsg.type == 'custom' && JSON.parse(res.lastMsg.content).type == 27) {
                                 content = JSON.parse(res.lastMsg.content).data.chatJobId 
                            }
                            let obj = {
                                cImName: res.id.split('-')[1],
                                jobId:content
                            }
                            if (!obj.jobId) {
                               delete obj.jobId
                            }
                            let data1 = await getChatInfo(obj);
                            let data2 = {...data1.resume,project:data1.project};
                            if (!data2.project) {
                               delete data2.project
                            }
                           
                            item = { ...data2, ...res.lastMsg, unread: res.unread, avatar: item.avatar, nick: item.nick };
                            newChatList.splice(index, 1,message(item));
                        }
                    }
                }
                state.chatList= newChatList;
                for (let index = 0; index < state.chatList.length; index++) {
                    if (state.currentChat.sessionId && state.chatList[index].sessionId == state.currentChat.sessionId) {
                        self("SET_CURRENTCHAT", state.chatList[index])
                    }
                }
                if (state.currentChat.sessionId) {
                    self('GET_CHATDETIAL', state.currentChat);
                }
                self('SET_ALLUNREAD', state.chatList);
            }
        },
        SET_NIM: (state, res) => {
            state.NIM = res;
        },
        SET_CURRENTCHAT: (state, res) => {
            state.currentChat = res;

        },
        // SET_LOAD_MENUS: (state, loadMenus) => {//操作user；
        //   state.loadMenus = loadMenus
        // }
        CLEAR_USER: (state, res) => { //操作user；
            state.user = {};
        },
        CLEAR_AUTH: (state, res) => { //操作user；
            state.menuAuth = [];
            state.routerAuth = [];
            state.buttonAuth = [];
        },
        GET_CHATDETIAL: (state, res) => { //操作user；
            state.loading = true;
            state.currentChat = res;
            if (res) {
                // 获取会话历史消息
                state.NIM.getLocalMsgs({
                    sessionId: state.currentChat.sessionId,
                    limit: 100,
                    done: getHistoryMsgsDone,
                });
            }
        },
        SET_IMUSER: (state, res) => { //操作user；
            state.userAccount= res.details.cimName;
            state.userPassword= res.details.imPassword;
        },
        INIT_NIM: (state) => { //操作user；
            let appkey1 = "7da73a3e2efc8612b87294afb22e42fd"; // 测试
            let appkey2 = "4b96bc51a08d72c5fc8192e1ce87544b"; // 正式
            const nim = NIM.getInstance({
                debug: false,   // 是否开启日志，将其打印到console。集成开发阶段建议打开。
                appKey: window.location.href.indexOf('crm.shangshaban') < 0 ?  appkey1: window.location.href.indexOf('test') > -1?appkey1:appkey2, // 云信控制台获取的 App Key   
                account: state.userAccount, // 云信控制台获取或服务端注册的用户账号 accid
                // account: '18562611881', // 云信控制台获取或服务端注册的用户账号 accid
                token: state.userPassword, // 云信控制台获取或服务端生成的静态 Token
                db: true, //若不要开启数据库请设置false。SDK默认为true。
                // privateConf: {}, // 私有化部署方案所需的配置
                onconnect: onConnect,
                onwillreconnect: onWillReconnect,
                ondisconnect: onDisconnect,
                onerror: onError,
                onmsg: onmsg,// 收到消息
                onsessions: onSessions,// 同步最近会话列表
                onupdatesession: onUpdateSession,// 更新会话
                // onofflinesysmsgs:onofflinesysmsgs,//监听消息撤回通知
                onsysmsg: onsysmsg,//监听消息撤回通知

            })
            setNIM(nim);
        }
    },

    actions: {
        // 登录
        Login({ commit }, res) {
            setUserInfo(res, commit);
            setAuth(res, commit);
        },
        initNIM({ commit }) {
            commit('INIT_NIM');
        },
        setCurrentChatItem({ commit }, res) {
            commit('SET_CURRENTCHAT', res);
        },
        getChatDetial({ commit }, res) {
            commit('GET_CHATDETIAL', res);
        },
  
        // 获取用户信息
        GetInfo({ commit, dispatch }) {
            self = commit;
            return new Promise((resolve, reject) => {
                getInfo().then(res => {
                    console.log(res);
                    setStore("uploadUserId", res.details.id);
                    setStore("cImName", res.details.cimName);
                    setStore("imPassword", res.details.imPassword);
                    setStore("head", res.details.head);
                    setStore("weChat", res.details.weChat);
                    setStore("deptId", res.details.deptId);
                    setStore("version", res.version);
                    setUserInfo(res, commit);
                    setStore('enterprisId', res.details.enterpriseId);
                    setAuth(res, commit);
                    self('SET_IMUSER',res)
                    self('SALE_version',res.version)
                    resolve(res)
                    dispatch('initNIM')
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 登出
        LogOut({ commit }) {
            console.log('我竟然走了？');
            Notification.closeAll();
            Cookies.remove('verifyCodeId');
            logOut(commit)
            setStore('visitedViews', JSON.stringify([]));
            router.push({ path: '/user' })
        },

        updateLoadMenus({ commit }) {
            return new Promise((resolve, reject) => {
                commit('SET_LOAD_MENUS', false)
            })
        },

        sale({ commit }, index) {
            commit('SALE_INDEX', index)
        },

        saleType({ commit }, type) {
            commit('SALE_TYPE', type)
        }
    }
}

export const logOut = (commit) => {
    commit('CLEAR_AUTH')
    commit('CLEAR_USER')
    commit('DESTROY')

    removeToken()
}

export const setUserInfo = (res, commit) => {
    commit('SET_USER', res)
}
export const setAuth = (res, commit) => {
    commit('SET_AUTH', res)
}

export const setNavs = (res, commit) => {
    commit('SET_NAVS', res);
}
export default user


// WEBPACK FOOTER //
// ./src/store/modules/user.js